import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { BULK_DELETE, DELETE } from "../../../../constants/actionButtons";
import { FeatureValueToggle } from "../../../../components/FeatureFlags/FeatureFlags";
import { FEATURES } from "../../../../constants/features";
import { getErrorMessage, renderTernary } from "../../../../helpers/utils";
import { Button, useSnackbar } from "@walmart-web/livingdesign-components";
import DeleteModal from "../../../../components/Modal/DeleteModal/DeleteModal";
import { BULK_INVOICE_DELETE, CONFIRM_INVOICE_DELETION } from "../../../../constants/constants";
import { BULK_UPDATE_INVOICE_STATUS_SUCCESS_MESSAGE, INVOICE_BULK_DELETE_MSG, INVOICE_BULK_DELETE_TXT } from "../../../../constants/messages";
import { InvoiceBulkResubmitStyles } from "../InvoiceBulkResubmit/InvoiceBulkResubmit.styles";
import { filterPayload } from "../../../../helpers/commonUtils";
import { INVOICE_SERVICE } from "../../../../constants/baseURLs";
import { postServiceWithHeaders } from "../../../../axios/axios";
import { TrashCan } from "@walmart-web/livingdesign-icons";


/**
* This Modal enables user to select bulk delete for the current selection
*/
const InvoiceBulkDelete = (props) => {
    const { bulkDeleteButtonOptions } = props;
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [bulkActionLoading, setBulkActionLoading] = useState(false);
    const classes = InvoiceBulkResubmitStyles()
    const { addSnack } = useSnackbar();
    const [jobId, setJobId] = useState();

    /**  Gets called when clicked on Delete button */
    const handleDeleteChange = () => {
        setDeleteModalOpen(true)
    };
    const handleSubmit = () => {
        setBulkActionLoading(true)
        const orgInvData = bulkDeleteButtonOptions?.invoiceIds?.reduce(function (acc, curr) {
            acc[curr['id']] = curr?.organizationInvoiceNumber
            return acc;
        }, {})
        const dataBag = {
            "invoiceNumberMap": orgInvData
        }
        const invoiceIds = bulkDeleteButtonOptions?.invoiceIds?.map(item => item.id);
        const body = {
            command: BULK_INVOICE_DELETE,
            identifiers: invoiceIds.join(","),
            validationType: "SYNC",
            executionType: "ASYNC",
            dataBag: JSON.stringify(dataBag)
        }
        const headers = {
            'Content-Type': `multipart/form-data`,
        };

        const filteredBody = filterPayload(body)
        postServiceWithHeaders(
            INVOICE_SERVICE,
            `/jobs/v1/submit`,
            filteredBody,
            headers
        )
            .then((response) => {
                const res = JSON.parse(response?.data)
                setJobId(res?.jobId);
                setBulkActionLoading(false)
            })
            .catch((error) => {
                setDeleteModalOpen(false)
                addSnack({
                    message: getErrorMessage(error)
                });
                setBulkActionLoading(false)
            })
    }
    useEffect(() => {
        setJobId()
    }, [setDeleteModalOpen])
    return (
        <>
            {renderTernary(FeatureValueToggle(FEATURES.INVOICE_PRE_VALIDATION, true, false),
                <div className={classes.resubmit}>
                    <Button
                        size="small"
                        variant="primary"
                        onClick={handleDeleteChange}
                        trailing={<TrashCan size="small" />}
                        data-testid="bulk-delete-btn"
                        disabled={bulkDeleteButtonOptions?.disableButton || bulkActionLoading}
                    >
                        {DELETE}
                    </Button>
                </div>, <></>)}
            <DeleteModal
                open={deleteModalOpen}
                setOpen={setDeleteModalOpen}
                title={CONFIRM_INVOICE_DELETION}
                message={jobId ?
                    <p id="success-message" data-testid="success-message">{BULK_UPDATE_INVOICE_STATUS_SUCCESS_MESSAGE}</p> :
                    <><div>{INVOICE_BULK_DELETE_MSG}</div>
                        <div className={classes.deleteMsgText}>{INVOICE_BULK_DELETE_TXT}</div></>}
                deleteButtonText={DELETE}
                onDelete={() => handleSubmit()}
                deleteLoading={bulkActionLoading}
                jobId={jobId}
                setJobId={setJobId}
                fromBulkDelete={true}
                reloadPage={bulkDeleteButtonOptions.reloadPage}
            />
        </>
    )
}
export default InvoiceBulkDelete;

InvoiceBulkDelete.propTypes = {
    bulkDeleteButtonOptions: PropTypes.object
};

InvoiceBulkDelete.defaultProps = {
    bulkDeleteButtonOptions: {}
}